// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2iXiK","buttons":"styles_buttons__3FQff"};